export default __webpack_public_path__ + "static/taskner4-f31f2915dc77f408e9190e1431f6c740.jpg";